import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

function PaginationComponent({ page, totalPages, onPageChange, isFetching }) {
  const [inputValue, setInputValue] = useState(page);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setInputValue(value);
      const num = Number(value);
      if (num >= 1 && num <= totalPages) {
        onPageChange(num);
      }
    }
  };

  // Sync input with page when parent updates page
  React.useEffect(() => {
    setInputValue(page);
  }, [page]);

  return (
    <div className="flex justify-center bg-white rounded-xl py-2 gap-3 pr-6 w-full">
      {/* Previous Button */}
      {totalPages !== 1 && (
        <button
          className="border border-customBlue text-customBlue py-2 px-3 rounded-lg focus:shadow-outline flex items-center justify-center"
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          style={{
            opacity: page === 1 ? 0.5 : undefined,
            cursor: page === 1 ? 'not-allowed' : 'pointer'
          }}>
          <ChevronLeft size={16} />
        </button>
      )}

      {/* Page Input */}
      <div className="flex items-center gap-2">
        <span className="text-customBlue">Page</span>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          className="w-12 text-center border border-customBlue rounded-lg py-2 px-2 focus:outline-none focus:ring-2 focus:ring-customBlue"
        />
        <span className="text-customBlue">of {totalPages}</span>
      </div>

      {/* Next Button */}
      {totalPages !== 1 && (
        <button
          className="border border-customBlue text-customBlue py-2 px-3 rounded-lg focus:shadow-outline flex items-center justify-center"
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages || isFetching}
          style={{
            opacity: page === totalPages || isFetching ? 0.5 : undefined,
            cursor: page === totalPages || isFetching ? 'not-allowed' : 'pointer'
          }}>
          <ChevronRight size={16} />
        </button>
      )}
    </div>
  );
}

export default PaginationComponent;
